import {Message , MessageBox} from 'element-ui'
import path from '@/url.js'
import { postHttp, getHttp } from '@/utils/vueresource.js'
const user = {
    namespaced: true,
    state: {
        userInfo: {}
    },
    mutations: {
        setUserInfo(state, payload = {}) {
            const simpleData = JSON.parse(localStorage.getItem("userInfo")) || {};
            state.userInfo = {
                ...simpleData,
                ...payload
            };
            if (Object.keys(payload).length > 0) {
                localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
            }
        },
        // 登出
        logOut(state) {
            console.log("logOut", "登出");
			state.userInfo = {};
			localStorage.removeItem("userInfo");
            Message({
				message:'您已退出登录',
				type:'success'
			})
        }
    },
    actions: {
        // 登录
        login(ctx, payload) {
            return new Promise(async (resolve, reject) => {
                let params = {
                    ...payload
                };
                const res = await getHttp(path.LOGIN_C, params);
                console.log("登录返回结果---->", res);
                if (res.data.code === 200) {
					Message({
						message: '登录成功',
            			type: 'success'
					})
                    ctx.commit("setUserInfo", res.data.data);
					resolve(res.data)
                } else {
					Message({
						message: res.data.msg,
            			type: 'error'
					})
					reject(res.data)
                }
            });
        }

        // 新增会员信息

        // 更新会员信息

    }
};
export default user;



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js